import React, { memo, useCallback, useState } from 'react';
import { BaseFilterMenu } from '../BaseFilterMenu';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { DEFAULT_OPTION } from './RadioButtonMenu.constants';
import { useStyles } from './RadioButtonMenu.styles';
import { ix } from '../../../../utils/ix';
import { useUpdateEffect } from '../../../../hooks/useUpdateEffect/useUpdateEffect';
export const RadioButtonMenu = memo(({ id, className, size, options, value, onChange }) => {
    const [isOpen, setOpen] = useState(false);
    const [localValue, setLocalValue] = useState(value);
    const classes = useStyles();
    const handleChange = (event) => {
        const pickedOption = options.find((option) => option.value === event.target.value);
        setLocalValue(pickedOption || DEFAULT_OPTION);
    };
    const handleChipClick = useCallback(() => {
        if (isOpen && localValue.value !== value.value) {
            onChange(localValue);
        }
        setOpen((previousValue) => !previousValue);
    }, [isOpen, localValue.value, value.value]);
    const handleClose = useCallback(() => {
        if (localValue.value !== value.value) {
            onChange(localValue);
        }
        setOpen(false);
    }, [localValue.value, value.value]);
    const renderChipContent = () => {
        const Icon = isOpen ? ExpandLessIcon : ExpandMoreIcon;
        return (React.createElement("div", { id: ix(id, 'chip-content'), className: classes.chipContent },
            React.createElement("span", { id: ix(id, 'chip-label') }, value.label),
            React.createElement(Icon, { className: classes.chipIcon, fontSize: "small" })));
    };
    const renderMenuContent = () => {
        return (React.createElement(RadioGroup, { value: localValue.value, onChange: handleChange }, options.map((option) => (React.createElement(FormControlLabel, { key: option.value, id: ix(id, 'option', option.value), className: classes.option, value: option.value, label: option.label, control: React.createElement(Radio, { size: "small" }) })))));
    };
    useUpdateEffect(() => {
        setLocalValue(value);
    }, [value.value]);
    return (React.createElement(BaseFilterMenu, { id: id, className: className, chipContent: renderChipContent(), menuContent: renderMenuContent(), open: isOpen, onChipClick: handleChipClick, onClose: handleClose, size: size }));
});
//# sourceMappingURL=RadioButtonMenu.js.map